import dayjs from "dayjs";
const formatDate = 'DD/MM/YYYY'

const dateDeNaissanceEnfantFromFn = (dateEffetInDDMMYYYY) => {
    const dateEffet = dayjs(dateEffetInDDMMYYYY, formatDate)

    return dateEffet.subtract(20,'years').format(formatDate)
}

const dateDeNaissanceEnfantToFn = () => {
    return dayjs().format(formatDate)
}

export {
    dateDeNaissanceEnfantFromFn,
    dateDeNaissanceEnfantToFn
}
